import { DEFAULT_FONT_SIZE, ROBOTO_FONT_FAMILY } from 'modules/core/theme/typography';

const minWidth = 150;
const defaultPadding = 30;
const defaultPixelsPerCharacter = 8;

/**
 * Fallback function to estimate text width based on character count
 */
const getFallbackTextWidth = (text: string): number => text.length * defaultPixelsPerCharacter;

/**
 * Utility function to calculate the width of text based on font properties
 */
export const calculateTextWidth = (
  text: string,
  fontSize: string = DEFAULT_FONT_SIZE,
  fontFamily: string = ROBOTO_FONT_FAMILY,
): number => {
  // Check if we're in a browser environment
  if (typeof document === 'undefined') {
    return getFallbackTextWidth(text);
  }

  // Create a temporary canvas element to measure text width
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  if (!context) {
    return getFallbackTextWidth(text);
  }

  context.font = `${fontSize} ${fontFamily}`;
  const metrics = context.measureText(text);

  return Math.ceil(metrics.width);
};

/**
 * Calculate the width needed for a dropdown based on its options
 */

export const calculateDropdownWidth = (
  options: Array<{ title: string; value: any }> = [],
  element?: HTMLElement, // Pass the actual dropdown element to get computed styles
  padding: number = defaultPadding,
): number => {
  if (!options || options.length === 0) {
    return minWidth;
  }

  let fontSize: string = DEFAULT_FONT_SIZE;
  let fontFamily: string = ROBOTO_FONT_FAMILY;

  if (element && typeof window !== 'undefined') {
    const computedStyle = window.getComputedStyle(element);

    fontSize = computedStyle.fontSize;
    fontFamily = computedStyle.fontFamily;
  }

  const maxTextWidth = Math.max(
    ...options.map((option) => calculateTextWidth(option.title || '', fontSize, fontFamily)),
  );

  return Math.max(minWidth, maxTextWidth + padding);
};
